import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";

declare var wNumb;

@Component({
  selector: "app-nouislider",
  templateUrl: "./nouislider.component.html",
  styleUrls: ["./nouislider.component.scss"],
})
export class NouisliderComponent {
  public disabled: boolean = false;
  @Input() someValue: number[] = [1, 10];
  @Input() someMin: number = 1;
  @Input() someMax: number = 10;
  @Input() tooltips: any = [];
  public connect: boolean = true;

  public someKeyboardConfig2: any = {
    behaviour: "drag",
    connect: true,
    step: 0.1,
    format: wNumb({
      decimals: 0,
    }),
    pips: {
      mode: "count",
      density: 2,
      values: 6,
      stepped: true,
    },
    keyboard: true,
  };

  constructor() {}

  ngOnInit() {}

  changeSomeRange(event) {}
}
